var watchlistPositionDelete = {
	title: "Eliminar posición",
	caption: "Posición para ser eliminada",
	name: "Nombe",
	alertHeading: "¿Está seguro de que desea eliminar esta posición?",
	alertBody: "En caso afirmativo, haga clic en eliminar. Tenga en cuenta que las posiciones eliminadas no se pueden restaurar",
	confirmBtn: "Eliminar",
	cancelBtn: "Cancelar"
};
var es = {
	watchlistPositionDelete: watchlistPositionDelete
};

export { es as default, watchlistPositionDelete };
